import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { DirectionsCar, CheckCircle } from "@material-ui/icons";
import Button from "../../components/Button";
import styles from "../../styles/Onboarding.module.scss";
import UserGroup from "../../components/icons/UserGroup";
import CreditCard from "../../components/icons/CreditCard";

const STEPS = [
    {
        icone_ativo: <UserGroup />,
        titulo: "Cadastre sua equipe",
        descricao: "Adicione os colaboradores que poderão solicitar e/ou acompanhar viagens corporativas, definindo níveis de acesso conforme a estrutura da sua empresa.",
        texto_cta: "Iniciar cadastro",
        rota: "/equipe/novo",
    },
    {
        icone_ativo: <CreditCard />,
        titulo: "Defina uma forma de pagamento",
        descricao: "Cadastre uma forma de pagamento para vincular às viagens solicitadas.",
        texto_cta: "Adicionar cartão",
        rota: "/configuracoes",
    },
    {
        icone_ativo: <DirectionsCar />,
        titulo: "Solicite sua primeira viagem",
        descricao: "Com sua equipe cadastrada e um método de pagamento definido, você já pode começar a solicitar viagens para todos.",
        texto_cta: "Solicitar viagem",
        rota: "/viagens/novo",
    },
];

export default function OnboardingPage() {
    const history = useHistory();
    const { passo_atual } = useSelector(({ onboarding }) => onboarding);

    // passo_atual vem do backend: 1, 2 ou 3 (base 1). Converte para índice base 0.
    const step_ativo = passo_atual ? passo_atual - 1 : 0;
    const steps_concluidos = [step_ativo > 0, step_ativo > 1, step_ativo > 2];

    return (
        <div className={styles.container}>
            <h2 className={styles.titulo}>Bem-vindo(a) à Chof!</h2>
            <p className={styles.subtitulo}>Para começar, siga as instruções abaixo para completar seu cadastro.</p>

            {STEPS.map((step, index) => {
                const concluido = steps_concluidos[index];
                const ativo = index === step_ativo;
                const futuro = index > step_ativo;

                let card_class = styles.stepCard;
                if (concluido) {
                    card_class = `${styles.stepCard} ${styles.stepCardConcluido}`;
                } else if (ativo) {
                    card_class = `${styles.stepCard} ${styles.stepCardAtivo}`;
                } else if (futuro) {
                    card_class = `${styles.stepCard} ${styles.stepCardFuturo}`;
                }

                return (
                    <div key={index} className={card_class}>
                        <div className={styles.stepHeader}>
                            {concluido ? (
                                <span className={styles.stepIconConcluido}>
                                    <CheckCircle />
                                </span>
                            ) : (
                                <span className={futuro ? styles.stepIconFuturo : styles.stepIconAtivo}>
                                    {step.icone_ativo}
                                </span>
                            )}
                            <p className={concluido ? styles.stepTituloConcluido : futuro ? styles.stepTituloFuturo : styles.stepTituloAtivo}>
                                {step.titulo}
                            </p>
                        </div>

                        {ativo && (
                            <>
                                <p className={styles.stepDescricao}>{step.descricao}</p>
                                <div className={styles.ctaButton}>
                                    <Button
                                        variant="primary"
                                        size="sm"
                                        onClick={() => history.push(step.rota)}
                                    >
                                        {step.texto_cta}&nbsp;&nbsp;<span class="material-symbols-outlined" style={{ fontSize: "20px" }}>arrow_forward</span>
                                    </Button>
                                </div>
                            </>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
